import { Box, SxProps, Typography } from '@mui/material';
import { UserOrganizationSubscriptionItem } from 'modules/campaigns/types/UserOrganizationSubscriptionItem';

const container: SxProps = {
  display: 'flex',
  alignItems: 'center',
  gap: 1
};

const teamsContainer: SxProps = {
  display: 'flex',
  gap: 0.5,
  borderRadius: 1,
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: 'customGrey.medium',
  px: 0.5,
  color: 'primary.main',
  cursor: 'pointer'
};

type Props = {
  userOrganizations: UserOrganizationSubscriptionItem[];
  onClick: () => void;
  isCampaignOwner: boolean;
};

export const CampaignTeamMembers: React.FC<Props> = ({
  userOrganizations,
  onClick,
  isCampaignOwner
}) => {
  return (
    <Box sx={container}>
      <Typography variant="body2">Team</Typography>

      <Box sx={teamsContainer} onClick={isCampaignOwner ? onClick : undefined}>
        <Typography fontWeight="bold" variant="body2">
          {userOrganizations[0].user.name}
        </Typography>
        {userOrganizations.length > 1 && (
          <Typography fontWeight="bold" variant="body2">{`& ${
            userOrganizations.length - 1
          } other${userOrganizations.length > 2 ? 's' : ''}`}</Typography>
        )}
      </Box>
    </Box>
  );
};
